import Image from 'next/image'

import { useContactInfo } from '@/api/models/common/hooks/useContactInfo'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { CallButton } from '@/components/shared/button/ui/CallButton'
import { formatPhoneNumber, makePhoneCallable } from '@/utils/number'

export const OwnerAccessPlug = () => {
  const { breakpoint } = useCurrentBreakpoint()

  const isMobileScreen = [ScreenSize.Xxs].includes(breakpoint)

  const { data: contactInfo, hasContactInfo } = useContactInfo()

  return (
    <div className="mb-40 flex h-full flex-col items-center justify-between xl:px-0 lg:px-16">
      <div className="mt-[100px] flex flex-col items-center gap-20">
        <Image
          src="/images/shared/forbidden.png"
          alt="forbidden"
          width={isMobileScreen ? 90 : 180}
          height={isMobileScreen ? 90 : 180}
        />
        <strong className="mb-8 mt-20 text-28 xxs:text-20">
          В доступе отказано
        </strong>
        <p className="text-center text-grey-80 text-20 xxs:text-16">
          У вас нет доступа к аренде паркинга.
          {hasContactInfo && (
            <>
              {' '}
              По всем вопросам обращайтесь в Службу комфорта Sminex:{' '}
              {contactInfo?.contactPhone && (
                <a
                  className="text-bronze-40 text-20 xxs:text-16"
                  href={`tel:${makePhoneCallable(contactInfo.contactPhone)}`}
                >
                  {formatPhoneNumber(contactInfo.contactPhone)}{' '}
                </a>
              )}
              {contactInfo?.contactEmail && (
                <>
                  или{' '}
                  <a
                    className="text-bronze-40 text-20 xxs:text-16"
                    href={`mailto:${contactInfo.contactEmail}`}
                  >
                    {contactInfo.contactEmail}
                  </a>
                </>
              )}
            </>
          )}
        </p>
      </div>

      <CallButton contactPhone={contactInfo?.contactPhone} />
    </div>
  )
}
